import { create } from 'zustand';
import { loadAllPosts, loadPost } from '../utils/blog/contentLoader';
import type { ProcessedPost } from '../utils/blog/types';

interface BlogState {
  posts: ProcessedPost[];
  categories: string[];
  popularPosts: ProcessedPost[];
  loading: boolean;
  error: Error | null;
  fetchPosts: () => void;
  getPostBySlug: (slug: string) => ProcessedPost | null;
}

export const useBlogStore = create<BlogState>((set, get) => ({
  posts: [],
  loading: false,
  error: null,
  categories: [],
  popularPosts: [],

  fetchPosts: () => {
    set({ loading: true, error: null });
    try {
      const posts = loadAllPosts();
      const categories = Array.from(new Set(posts.map(post => post.category)));
      const popularPosts = [...posts]
        .sort((a, b) => b.views - a.views)
        .slice(0, 5);

      set({ posts, categories, popularPosts, loading: false });
    } catch (error) {
      console.error('Error loading posts:', error);
      set({ error: error as Error, loading: false });
    }
  },

  getPostBySlug: (slug: string) => {
    return loadPost(slug);
  }
}));